export default "__VITE_ASSET__Dk3Yzvf1__"